import http from "./httpClient.js";

export async function getUsers(token, schoolId = null) {
    const params = schoolId ? { schoolId } : {};
    const response = await http.get(`/users`, {
        headers: {
            Authorization: `Bearer ${token}`
        },
        params,
    });
    return response.data;
}

export async function teacherGetMyAttendanceByMonth(token) {
    const response = await http.get(`/users/teacher-attendance`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

export async function updateProfile(token, payload) {
    const response = await http.patch(`/users/updateMe`, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}

export async function getMySchoolAccess(token) {
    const response = await http.get(`/users/my-school-access`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
}

export async function toggleSchoolAccess(token, schoolId) {
    const response = await http.patch(`/users/my-school-access/${schoolId}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
}